/**
 * @deprecated use instance in '/shared/functions/' lib
 * this avoids common circular dependancy error
 */
export function stringMatchHighlight(str: string, search?: string) {
  if (str) {
    const re = new RegExp('(' + search + ')', 'gi');
    const substr = '<strong class="search-match">$1</strong>';
    const match = str.replace(re, substr);

    return match;
  }

  return str || '';
}
